var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"edit-product"}},[(_vm.product)?_c('div',{staticClass:"p-4"},[_c('product-details',{attrs:{"product":_vm.product},on:{"productUpdated":_vm.fetchProduct,"refreshProduct":_vm.fetchProduct}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }